export const accordionSx = {
  "& .accordion-item": {
    borderBottom: "none",
  },
  "& .glide-accordion .accordion-content": {
    overflowY: "auto !important",
    overflowX: "hidden !important",
    WebkitOverflowScrolling: "touch",
  },
};
